module.exports = __webpack_public_path__ + "img/A58A0224_min.c7e8b8ac.jpg";